import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageTitle({ title, crumbs = [] }) {
  return (
    <section className="relative bg-gradient-to-r from-[#b81d24] to-[#7d1318] text-white">
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7')" }}
      />
      <div className="relative max-w-7xl mx-auto px-4 py-16 md:py-20 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-3">{title}</h1>
        <div className="flex items-center justify-center gap-2 text-amber-300 mb-2">
          <span className="h-[2px] w-6 bg-amber-300"></span>
          <span className="text-2xl leading-none">♥</span>
          <span className="h-[2px] w-6 bg-amber-300"></span>
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-white/80">
          <Link to="/" className="hover:text-amber-300">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="w-4 h-4" />
              {c.to ? (
                <Link to={c.to} className="hover:text-amber-300">{c.label}</Link>
              ) : (
                <span>{c.label}</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
